<template>
  <div>
    <div v-if="pointinfo" class="container-info">
      <div class="info-point">
        <div v-if="pointinfo" class="point-style">
          <div class="point-style__header">
            <h2 class="organisme">{{ pointinfo["Nom de l'organisme"] }}</h2>
            <div class="city">{{ pointinfo['Ville'] }}</div>
          </div>
          <div class="point-style__body">
            <div v-if="pointinfo['Adresse']" class="point-style__body__element">
              <div class="element-header">ADRESSE</div>
              {{ pointinfo['Adresse'] }} , {{ pointinfo['Ville'] }}
              {{ pointinfo['Code postal'] }}
            </div>
            <div class="point-style__body__element">
              <div class="element-header">CONTACT</div>

              <div v-if="pointinfo['Courriels carte']" class="link">
                <a
                  :href="`mailto:${pointinfo['Courriels carte']}`"
                  target="_parent"
                >
                  <i class="fas fa-envelope"></i>
                  {{ pointinfo['Courriels carte'] }}
                </a>
              </div>
              <div v-if="pointinfo['Téléphone']" class="link">
                <a :href="`tel:${pointinfo['Téléphone']}`" target="_parent">
                  <i class="fas fa-phone"></i>
                  {{ pointinfo['Téléphone'] }}
                </a>
              </div>
              <div v-if="pointinfo['Site internet']" class="link">
                <a :href="`${pointinfo['Site internet']}`" target="_parent">
                  <i class="fas fa-globe"></i>
                  Site Web
                </a>
              </div>
              <div v-if="pointinfo['Facebook']" class="link">
                <a :href="`${pointinfo['Facebook']}`" target="_parent">
                  <i class="fab fa-facebook-f"></i>
                  Page Facebook
                </a>
              </div>
            </div>
            <div
              v-if="pointinfo['Territoire couvert']"
              class="point-style__body__element"
            >
              <div class="element-header">TERRITOIRE COUVERT</div>
              {{ pointinfo['Territoire couvert'] }}
            </div>
            <div v-if="!isProd" class="point-style__body__element">
              <a :href="fillGoogleFormTemplate(pointinfo)"
                >[* prévisualisation formulaire *]</a
              >
            </div>
            <div
              v-if="pointinfo['rocqtr'] === 'Oui'"
              class="point-style__body__element point-style__body__logo"
            >
              <img src="../assets/ROCQTR_COUL.jpg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fillGoogleFormTemplate } from '@/mailingDataHelper'
export default {
  props: {
    pointinfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isProd: process.env.NODE_ENV === 'production'
    }
  },
  methods: {
    fillGoogleFormTemplate
  }
}
</script>

<style lang="scss" scoped>
i {
  margin-right: 8px;
}
.link {
  margin: 8px 0;
  @media (max-width: 1023px) {
    margin: 4px 0;
  }
}
.container-info {
  margin: 0;
  padding: 0;
}

.info-point {
  font-weight: 600;
  margin: 32px;
  margin-bottom: 0;
  @media (min-width: 1024px) {
    margin-bottom: 48px;
  }
}
.point-style {
  font-family: 'Raleway', Helvetica, Arial, sans-serif;
  margin: 5px;
  a {
    text-decoration: none;
    font-weight: 600;
    color: black;
  }
  a:hover {
    color: darkgrey;
  }
  &__header {
    h2 {
      font-size: 1.5rem;
      margin-block-end: 0.25rem;
    }
    .city {
      font-size: 0.9rem;
      font-weight: 600;
      color: grey;
    }
    margin-bottom: 24px;
  }
  &__body {
    &__element {
      margin: 16px 0;
      .element-header {
        font-size: smaller;
        color: grey;
        font-weight: 600;
        margin-bottom: 4px;
      }
    }
    &__logo {
      margin: 0;
      img {
        width: 280px;
        margin-top: -14px;
        margin-left: -35px;
        margin-bottom: -35px;
        @media (max-width: 1023px) {
          width: 260px;
          margin-left: -33px;
        }
        @media (max-width: 768px) {
          width: 240px;
          margin-left: -31px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
